import { render, staticRenderFns } from "./UserPerformance.vue?vue&type=template&id=45d812b2&"
import script from "./UserPerformance.vue?vue&type=script&lang=js&"
export * from "./UserPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports